<script>
  import { getContext } from "svelte";
  import { Link } from "svelte-routing";
  import { _ as t } from "svelte-i18n";

  import { authToken } from "stores.js";
  import { loginUser, forgotPassword } from "login.js";

  import LoginModal from "LoginModal.svelte";

  export let appLogin;
  export let appLogout;

  const { open, close } = getContext("simple-modal");

  const handleLogin = (e) => {
    e.preventDefault();
    e.stopPropagation();

    open(LoginModal, {
      onLogin: (session) => {
        appLogin(session.token);
        close();
      },
      onClose: () => {
        close();
      },
      loginUser: loginUser,
      forgotPassword: forgotPassword,
    });
  };

  const handleLogout = () => {
    appLogout();
  };
</script>

<div>
  <div class="login">
    {#if $authToken}
      <Link to="/account">
        <span class="button">{$t("myAccount")}</span>
      </Link>
      <span class="dot-decoration">•</span>
      <button class="button" on:click={handleLogout}>{$t("logout")}</button>
    {:else}
      <button class="button" on:click={handleLogin}>{$t("login")}</button>
    {/if}
  </div>
</div>

<style>
  .login {
    margin-top: 24px;
    text-align: right;
  }

  .button {
    padding: 0 4px;
    margin: 0;
    text-transform: uppercase;
    font-size: 18px;
    color: #999;
    border: none;
    outline: none;
    background-color: inherit;
    cursor: pointer;
  }

  .button:hover {
    color: black;
  }

  .dot-decoration {
    font-size: 12px;
    color: #999;
  }
</style>
